document.addEventListener('DOMContentLoaded', function() {
    var variantInputs = document.querySelectorAll('.product-form__swatch input[type="radio"], .product-form__swatch button');

    function updateVariantDisplay(e) {
        var selectedValue = e.target.tagName === 'BUTTON' ? e.target.getAttribute('data-value') : e.target.value;
        var optionName = e.target.name;
        var variantDisplay = document.getElementById('selected' + optionName);
        
        if(variantDisplay) {
            variantDisplay.textContent = selectedValue;
        }
    }

    variantInputs.forEach(function(input) {
        input.addEventListener('change', updateVariantDisplay);
        if(input.tagName === 'BUTTON') {
            input.addEventListener('click', updateVariantDisplay);
        }
    });
  
    var currentPage = window.location.href;
    // console.log(typeof currentPage);
    var labels = document.querySelectorAll('.product-form__swatch label');
    labels.forEach(function(label) {
        label.addEventListener('click', function() {
            var imageURL = this.getAttribute('url');
            // window.location.href = '';
            // console.log(typeof imageURL);
            if (!currentPage.includes(imageURL)){
              window.location.href = imageURL;
            }
        });
    });
});